const HowToListVideo = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
      <div className="relative overflow-hidden rounded-2xl border border-[#2D96A7]/20 bg-gradient-to-br from-[#2D96A7]/5 via-white to-white">
        <div className="relative px-6 md:px-12 py-12 md:py-14">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 tracking-tight mb-2">
              How to List a Property on FNP
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              Watch our quick walkthrough and get your property live in minutes.
            </p>
          </div>
          <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-sm">
            <iframe
              src="https://www.youtube.com/embed/mkWjqAAcyQg"
              title="How to list a property on FNP"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full border-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToListVideo;
